type User = {
   first_name?: string | null;
   last_name?: string | null;
};

export const getFullName = <T extends User>(props: T) => {
    return [props.first_name, props.last_name].join(' ');
};
